module.exports = __webpack_public_path__ + "img/800px-HTML5_logo_and_wordmark.svg-min.98d91505.png";